var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main_container"},[_c('div',[_c('div',{attrs:{"id":"app"}},[_c('router-view',{key:_vm.$route.fullPath,staticClass:"router_view"}),(_vm.suspendedPlayerMode === 1)?_c('suspended-player'):_vm._e()],1)]),_c('pc-preview')],1)}
var staticRenderFns = []

export { render, staticRenderFns }